<template>
  <HeaderContent title="Guest" />
  <ActionContent
    ctaText="Add Guest"
    @action="showModal"
    :filterDate="false"
    :filterModal="false"
    @search-query="searchData"
  />
  <GuestStatistics title="Guest Statistics" :data="statistics" />
  <GuestForm
    :modal="modal"
    :guestData="guest"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <GuestFilter
    :modalFilter="modalFilter"
    @update:modalFilter="modalFilter = $event"
  />
  <GuestConfirm
    title="Confirmation"
    :uuid="guestUuid"
    v-model="modalConfirm"
    @confirmed="deleteData(guestUuid)"
  >
    <template #text>Are you sure to delete this data ?</template>
  </GuestConfirm>
  <!-- *codingan lama: madhan* -->
  <!-- <GuestDataTable
    :data="guests"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  /> -->

  <!-- *codingan baru: naldi* -->
   <!-- Refactor DataTable agar support pagination -->
  <GuestDataTable
    :data="guests"
    :header="headers"
    :custom-actions="customActions"
    :currentPage="currentPage"
    :perPage="perPage"
    :total="total" 
    @page-changed="handlePageChange"
    @per-page-changed="handlePerPageChange"
  />
    <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  ></ToastResponse>
</template>

<script>
import { ref, inject, onMounted } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContentGuest.vue";
import _ from "lodash";
import GuestForm from "./GuestForm.vue";
import GuestFilter from "./GuestFilter.vue";
import GuestConfirm from "@/components/ModalDialog.vue";
import GuestStatistics from "@/components/StatisticData.vue";
import GuestDataTable from "@/components/DataTable.vue";
import iconForeign from "../../../public/icons/user-cowboy.svg";
import iconLocal from "../../../public/icons/people-roof.svg";
import iconStay from "../../../public/icons/street-view.svg";
import iconOveral from "../../../public/icons/square-poll-vertical.svg";
//import guestDateFormatter from "@/composable/guestDateFormatter.js";

//alternatif best case -! { getFormattedDate, getFormattedDateTime } utk panggil 2 format sekaligus
import { getFormattedDateTime } from '@/composable/getDateTimeFormatter';
import ToastResponse from "@/components/ToastResponse.vue";



export default {
  components: {
    HeaderContent,
    ActionContent,
    GuestForm,
    GuestFilter,
    GuestConfirm,
    GuestStatistics,
    GuestDataTable,
    ToastResponse,
  },
  setup() {
    const repositories = inject("repositories");
    const guestRepository = repositories ? repositories.guests : null;

    const modal = ref(false);
    const modalFilter = ref(false);
    const modalConfirm = ref(false);

    const currentPage = ref(1);
    const perPage = ref(200);
    const total = ref(0);
    const searchQuery = ref("");

    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });


    const guestUuid = ref(null);
    const guest = ref({});
    const guests = ref([]);
    const headers = ref([
      {
        key: "no",
        label: "#",
      },
      {
        key: "identity_number",
        label: "ID/Passport",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "fullname",
        label: "Name",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "nationality",
        label: "Nationality",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "phone",
        label: "Contact No",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "city",
        label: "City",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
      },
      {
        key: "address",
        label: "Address",
        sortable: true,
      },
      {
        key: "created_ats",
        label: "Registered On",
        sortable: true,
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);
    const customActions = ref([
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);
    const statistics = ref([]);

    //**codingan baru: naldi */
    const pagination = ref({
      current_page: 1,
      per_page: 200,
      total: 0,
    });

    const keyword = ref("");

    // Fetch data guest
    const fetchGuests = async (page = 1) => {
      try {
        const res = await guestRepository.getAll({
          keyword: keyword.value,
          per_page: pagination.value.per_page,
          page,
        })


        guests.value = res.data.data
        
        pagination.value.total = res.data.meta?.total ?? 0
        pagination.value.current_page = res.data.meta?.current_page ?? page
        pagination.value.last_page = res.data.meta?.last_page ?? 1
      } catch (error) {
        console.error("Gagal fetch guests:", error);
      }
    };

    // Fungsi search
    const searchGuests = () => {
      fetchGuests(1);
    };

    // Fungsi pindah halaman
    const changePage = (page) => {
      fetchGuests(page);
    };

    // //** codingan lama: madhan **
    // const getAll = async (params) => {
    //   const getAlias = (x) => {
    //     return _.upperCase(x[0]) + x.slice(1);
    //   };

    //   await guestRepository
    //     .getAll(params)
    //     .then((res) => {

    //       console.log("Statistics Data:", res.data.statistics);

    //       guests.value = res.data.data.map((i) => ({
    //         ...i,
    //         fullname: getAlias(i.alias) + ". " + i.fullname,
    //         created_ats: getFormattedDateTime(i.created_at),
    //       }));
    //       statistics.value = [
    //         {
    //           label: "Total",
    //           key: "Foreign Guest",
    //           value: res.data.statistics.foreign,
    //           color: "info",
    //           icon: iconForeign,
    //         },
    //         {
    //           label: "Total",
    //           key: "Local Guest",
    //           value: res.data.statistics.local,
    //           color: "primary",
    //           icon: iconLocal,
    //         },
    //         {
    //           label: "Total",
    //           key: "Staying Guest",
    //           value: res.data.statistics.staying,
    //           color: "primary",
    //           icon: iconStay,
    //         },
    //         {
    //           label: "Total",
    //           key: "Overall Guest",
    //           value: res.data.statistics.total,
    //           color: "primary",
    //           icon: iconOveral,
    //         },
    //       ];
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    // };

    //** codingan baru: naldi **
    const getAll = async (extraParams = {}) => {
      const getAlias = (x) => _.upperCase(x[0]) + x.slice(1);

      // gabungkan default params dengan extraParams
      const params = {
        page: currentPage.value,
        per_page: perPage.value,
        keyword: searchQuery.value,
        ...extraParams,
      };

      try {
        const res = await guestRepository.getAll(params);

        console.log("Statistics Data:", res.data.statistics);

        // isi data tabel
        guests.value = res.data.data.map((i) => ({
          ...i,
          fullname: getAlias(i.alias) + ". " + i.fullname,
          created_ats: getFormattedDateTime(i.created_at),
        }));

        // isi statistik
        statistics.value = [
          {
            label: "Total",
            key: "Foreign Guest",
            value: res.data.statistics.foreign,
            color: "info",
            icon: iconForeign,
          },
          {
            label: "Total",
            key: "Local Guest",
            value: res.data.statistics.local,
            color: "primary",
            icon: iconLocal,
          },
          {
            label: "Total",
            key: "Staying Guest",
            value: res.data.statistics.staying,
            color: "primary",
            icon: iconStay,
          },
          {
            label: "Total",
            key: "Overall Guest",
            value: res.data.statistics.total,
            color: "primary",
            icon: iconOveral,
          },
        ];

        // simpan pagination dari API
        total.value = res.data.meta?.total ?? 0;
        currentPage.value = res.data.meta?.current_page ?? 1;
        perPage.value = res.data.meta?.per_page ?? perPage.value;
      } catch (err) {
        console.error(err);
      }
    };

    const getById = async (uuid) => {
      await guestRepository
        .getById(uuid)
        .then((res) => {
          guest.value = res.data.data;
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };
    const updateModal = (newValue) => {
      modal.value = newValue;
      guest.value = {};
    };
    const showModal = () => {
      modal.value = true;
    };
    const showConfirmModal = async (uuid) => {
      modalConfirm.value = true;
      guestUuid.value = uuid;
      console.log(guestUuid.value);
    };
    const deleteData = async (uuid) => {
      await guestRepository
        .delete(uuid)
        .then(() => {
          modalConfirm.value = false;
          getAll();
          modalResponse.value.success = true;
          modalResponse.value.text = "Guest deleted successfully";
          modalResponse.value.toast = true;
        })
        .catch((err) => {
          modalResponse.value.success = false;
          modalResponse.value.text = err.response.data.message;
          modalResponse.value.toast = true;
        });
    };

    // //** codingan baru: madhan **
    // const searchData = async (keyword) => {
    //   await guestRepository
    //     .search(keyword)
    //     .then((res) => {
    //       guests.value = res.data.data;
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    // };

    const searchData = async (keyword) => {
      searchQuery.value = keyword;   // simpan keyword ke state
      currentPage.value = 1;         // reset ke page 1 tiap search
      await getAll();                // panggil index dengan keyword + pagination
    };

    const handlePageChange = (page) => {
      currentPage.value = page
      getAll()
    }

    const handlePerPageChange = (size) => {
      perPage.value = size
      currentPage.value = 1
      getAll()
    }

    onMounted(() => {
      getAll();
      fetchGuests();
    });

    return {
      getAll,
      getById,
      updateModal,
      showModal,
      showConfirmModal,
      deleteData,
      guestUuid,
      guests,
      guest,
      headers,
      modal,
      modalFilter,
      modalConfirm,
      currentPage,
      customActions,
      statistics,
      searchData,
      searchGuests,
      changePage,
      pagination,
      perPage,
      total,
      handlePageChange,
      handlePerPageChange,
      modalResponse,
    };
  },
};
</script>

<style></style>
